var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { containerStaticStyle, loaderPathStaticStyle, loaderSvgStaticStyle, logomarkWrapperStyle, svgWrapperStaticStyle, } from './styles';
function Logomark(_a) {
    var { 'aria-label': ariaLabel, inverted = false } = _a, restProps = __rest(_a, ['aria-label', "inverted"]);
    const { height, width } = restProps;
    return (_jsx("div", Object.assign({ "aria-label": ariaLabel, css: logomarkWrapperStyle({ height, inverted, width }), "data-testid": "loader-wrapper", role: "alert" }, { children: _jsx("div", Object.assign({ css: containerStaticStyle }, { children: _jsx("div", Object.assign({ css: svgWrapperStaticStyle }, { children: _jsx("svg", Object.assign({ css: loaderSvgStaticStyle, viewBox: "0 0 2640 3444" }, restProps, { children: _jsx("path", { css: loaderPathStaticStyle, d: "M0 0 M2569 1056L143 2447V149l1175 673v1867l1248 715", fill: "none", strokeLinejoin: "round", strokeWidth: "300" }) })) })) })) })));
}
export default Logomark;
